import { renderCarousel } from "@giphy/js-components";
import { GiphyFetch } from "@giphy/js-fetch-api";

const gf = new GiphyFetch("3S8uTVPgzCqQJ92QGxAz26od8kLOJSOo");
var search: string;
var type: string;
var fetchGifs = (offset: number) => gf.search(search, { offset, limit: 10 });
var url: string;
export class VanillaJSCarousel {
  mountElement: HTMLElement;
  gifClickListener: HTMLElement;
  constructor(
    mountElement: HTMLElement,
    input: string,
    gifClickListener: HTMLElement
  ) {
    this.mountElement = mountElement;
    this.gifClickListener = gifClickListener;
    search = input;
    //fetchGifs
    this.buildCarousel();
  }

  buildCarousel = () => {
    renderCarousel(
      {
        gifHeight: 100,
        user: {},
        fetchGifs,
        gutter: 6,
        onGifClick: (gif) => {
          this.mountElement.onclick = function (event) {
            event.preventDefault();
          };
          url = gif.id.toString();
          //console.log("bit1: " + gif.bitly_url);
          //console.log("bit2: " + gif.content_url);
          //console.log("bit3: " + gif.embed_url);
          //console.log("bit4: " + gif.id);
          this.gifClickListener.click();
        },
        key: search,
      },
      this.mountElement
    );
  };

  searchGiphy(term: string) {
    search = term;
    this.buildCarousel();
  }
  getUrl() {
    return url;
  }
}
